import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    this.originalOptions = new WeakMap()
    this.refreshOptions()
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.refreshOptions()
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest(".nested-fields")
    
    // Handle destroy field if it exists
    const destroyField = item.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = 1
      item.querySelectorAll("[required]").forEach(field => { field.required = false })
      item.style.display = "none"
    } else {
      item.remove()
    }
    this.refreshOptions()
  }

  refreshOptions() {
    const selects = Array.from(this.containerTarget.querySelectorAll("select[data-related-talent-select]"))
      .filter(select => {
        const destroyField = select.closest(".nested-fields").querySelector("input[name*='_destroy']")
        return !destroyField || !["1", "true"].includes(destroyField.value)
      })
    const selectedValues = new Set(selects.map(select => select.value).filter(Boolean))

    selects.forEach(select => {
      if (!this.originalOptions.has(select)) {
        this.originalOptions.set(select, Array.from(select.options, option => option.cloneNode(true)))
      }

      const currentValue = select.value
      const options = this.originalOptions.get(select)
        .filter(option => !option.value || option.value === currentValue || !selectedValues.has(option.value))
        .map(option => option.cloneNode(true))
      select.replaceChildren(...options)
      select.value = currentValue
    })
  }
}
